import React from "react";
import { Container, Stack } from "@mui/material";
import { HeaderToolbar } from "../components/header-toolbar";

interface AdminLayoutProps {
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  showNavigation?: boolean;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  maxWidth = "xl",
  showNavigation = true,
}) => {
  return (
    <Stack
      justifyContent="top"
      alignItems="center"
      spacing={0}
      sx={{
        minHeight: "100vh",
        backgroundColor: "#F5F5F5",
      }}
    >
      {showNavigation && <HeaderToolbar />}
      <Container maxWidth={maxWidth} sx={{ px: 2, py: 2, flex: 1 }}>
        {children}
      </Container>
    </Stack>
  );
};

export default AdminLayout;
